import filterAvailableDate from "./filterAvailableDate";

const getDateDetails = (date, schedule) => {
  const availabilities = filterAvailableDate(schedule.availabilities, date);
  const timeslots = filterAvailableDate(schedule.timeslots, date);
  return {
    availabilities,
    timeslots
  };
};

export default getDateDetails;